import _defineProperty from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
import { __asyncDelegator, __asyncGenerator, __asyncValues, __await } from "tslib";
import * as coreClient from "@azure/core-client";
import * as coreRestPipeline from "@azure/core-rest-pipeline";
import * as Parameters from "./models/parameters";
import * as Mappers from "./models/mappers"; /// <reference lib="esnext.asynciterable" />

export var GeneratedClient = /*#__PURE__*/function (_coreClient$ServiceCl) {
  _inherits(GeneratedClient, _coreClient$ServiceCl);

  /**
   * Initializes a new instance of the GeneratedClient class.
   * @param endpoint Supported Cognitive Services endpoints (protocol and hostname, for
   *                 example: https://westus2.api.cognitive.microsoft.com).
   * @param options The parameter options
   */
  function GeneratedClient(endpoint, options) {
    var _this;

    _classCallCheck(this, GeneratedClient);

    var _a, _b;

    if (endpoint === undefined) {
      throw new Error("'endpoint' cannot be null");
    } // Initializing default values for options


    if (!options) {
      options = {};
    }

    var defaults = {
      requestContentType: "application/json; charset=utf-8"
    };
    var packageDetails = "azsdk-js-ai-form-recognizer/4.0.0-beta.4";
    var userAgentPrefix = options.userAgentOptions && options.userAgentOptions.userAgentPrefix ? "".concat(options.userAgentOptions.userAgentPrefix, " ").concat(packageDetails) : "".concat(packageDetails);
    var optionsWithDefaults = Object.assign(Object.assign(Object.assign({}, defaults), options), {
      userAgentOptions: {
        userAgentPrefix: userAgentPrefix
      },
      baseUri: (_b = (_a = options.endpoint) !== null && _a !== void 0 ? _a : options.baseUri) !== null && _b !== void 0 ? _b : "{endpoint}/formrecognizer"
    });
    _this = _possibleConstructorReturn(this, _getPrototypeOf(GeneratedClient).call(this, optionsWithDefaults));

    if ((options === null || options === void 0 ? void 0 : options.pipeline) && options.pipeline.getOrderedPolicies().length > 0) {
      var pipelinePolicies = options.pipeline.getOrderedPolicies();
      var bearerTokenAuthenticationPolicyFound = pipelinePolicies.some(function (pipelinePolicy) {
        return pipelinePolicy.name === coreRestPipeline.bearerTokenAuthenticationPolicyName;
      });

      if (!bearerTokenAuthenticationPolicyFound) {
        _this.pipeline.removePolicy({
          name: coreRestPipeline.bearerTokenAuthenticationPolicyName
        });

        _this.pipeline.addPolicy(coreRestPipeline.bearerTokenAuthenticationPolicy({
          scopes: "".concat(optionsWithDefaults.baseUri, "/.default"),
          challengeCallbacks: {
            authorizeRequestOnChallenge: coreClient.authorizeRequestOnClaimChallenge
          }
        }));
      }
    } // Parameter assignments


    _this.endpoint = endpoint; // Assigning values to Constant parameters

    _this.apiVersion = options.apiVersion || "2022-06-30-preview";

    _this.addCustomApiVersionPolicy(options.apiVersion);

    return _this;
  }
  /** A function that adds a policy that sets the api-version (or equivalent) to reflect the library version. */


  _createClass(GeneratedClient, [{
    key: "addCustomApiVersionPolicy",
    value: function addCustomApiVersionPolicy(apiVersion) {
      if (!apiVersion) {
        return;
      }

      var apiVersionPolicy = {
        name: "CustomApiVersionPolicy",
        sendRequest: function () {
          var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request, next) {
            var param, newParams;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    param = request.url.split("?");

                    if (param.length > 1) {
                      newParams = param[1].split("&").map(function (item) {
                        if (item.indexOf("api-version") > -1) {
                          return item.replace(/(?<==).*$/, apiVersion);
                        } else {
                          return item;
                        }
                      });
                      request.url = param[0] + "?" + newParams.join("&");
                    }

                    return _context.abrupt("return", next(request));

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function sendRequest(_x, _x2) {
            return _sendRequest.apply(this, arguments);
          }

          return sendRequest;
        }()
      };
      this.pipeline.addPolicy(apiVersionPolicy);
    }
    /**
     * Lists all operations.
     * @param options The options parameters.
     */

  }, {
    key: "listOperations",
    value: function listOperations(options) {
      var _this2 = this,
          _ref;

      var iter = this.getOperationsPagingAll(options);
      return _ref = {
        next: function next() {
          return iter.next();
        }
      }, _defineProperty(_ref, Symbol.asyncIterator, function () {
        return this;
      }), _defineProperty(_ref, "byPage", function byPage() {
        return _this2.getOperationsPagingPage(options);
      }), _ref;
    }
  }, {
    key: "getOperationsPagingPage",
    value: function getOperationsPagingPage(options) {
      return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime().mark(function getOperationsPagingPage_1() {
        var result, continuationToken;
        return _regeneratorRuntime().wrap(function getOperationsPagingPage_1$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __await(this._getOperations(options));

              case 2:
                result = _context2.sent;
                _context2.next = 5;
                return __await(result.value || []);

              case 5:
                _context2.next = 7;
                return _context2.sent;

              case 7:
                continuationToken = result.nextLink;

              case 8:
                if (!continuationToken) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 11;
                return __await(this._getOperationsNext(continuationToken, options));

              case 11:
                result = _context2.sent;
                continuationToken = result.nextLink;
                _context2.next = 15;
                return __await(result.value || []);

              case 15:
                _context2.next = 17;
                return _context2.sent;

              case 17:
                _context2.next = 8;
                break;

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, getOperationsPagingPage_1, this);
      }));
    }
  }, {
    key: "getOperationsPagingAll",
    value: function getOperationsPagingAll(options) {
      return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime().mark(function getOperationsPagingAll_1() {
        var e_1, _a, _b, _c, page;

        return _regeneratorRuntime().wrap(function getOperationsPagingAll_1$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _b = __asyncValues(this.getOperationsPagingPage(options));

              case 2:
                _context3.next = 4;
                return __await(_b.next());

              case 4:
                _c = _context3.sent;

                if (_c.done) {
                  _context3.next = 14;
                  break;
                }

                page = _c.value;
                _context3.t0 = __await;
                return _context3.delegateYield(__asyncDelegator(__asyncValues(page)), "t1", 9);

              case 9:
                _context3.t2 = _context3.t1;
                _context3.next = 12;
                return (0, _context3.t0)(_context3.t2);

              case 12:
                _context3.next = 2;
                break;

              case 14:
                _context3.next = 19;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t3 = _context3["catch"](0);
                e_1 = {
                  error: _context3.t3
                };

              case 19:
                _context3.prev = 19;
                _context3.prev = 20;

                if (!(_c && !_c.done && (_a = _b.return))) {
                  _context3.next = 24;
                  break;
                }

                _context3.next = 24;
                return __await(_a.call(_b));

              case 24:
                _context3.prev = 24;

                if (!e_1) {
                  _context3.next = 27;
                  break;
                }

                throw e_1.error;

              case 27:
                return _context3.finish(24);

              case 28:
                return _context3.finish(19);

              case 29:
              case "end":
                return _context3.stop();
            }
          }
        }, getOperationsPagingAll_1, this, [[0, 16, 19, 29], [20,, 24, 28]]);
      }));
    }
    /**
     * List all models
     * @param options The options parameters.
     */

  }, {
    key: "listModels",
    value: function listModels(options) {
      var _this3 = this,
          _ref2;

      var iter = this.getModelsPagingAll(options);
      return _ref2 = {
        next: function next() {
          return iter.next();
        }
      }, _defineProperty(_ref2, Symbol.asyncIterator, function () {
        return this;
      }), _defineProperty(_ref2, "byPage", function byPage() {
        return _this3.getModelsPagingPage(options);
      }), _ref2;
    }
  }, {
    key: "getModelsPagingPage",
    value: function getModelsPagingPage(options) {
      return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime().mark(function getModelsPagingPage_1() {
        var result, continuationToken;
        return _regeneratorRuntime().wrap(function getModelsPagingPage_1$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __await(this._getModels(options));

              case 2:
                result = _context4.sent;
                _context4.next = 5;
                return __await(result.value || []);

              case 5:
                _context4.next = 7;
                return _context4.sent;

              case 7:
                continuationToken = result.nextLink;

              case 8:
                if (!continuationToken) {
                  _context4.next = 19;
                  break;
                }

                _context4.next = 11;
                return __await(this._getModelsNext(continuationToken, options));

              case 11:
                result = _context4.sent;
                continuationToken = result.nextLink;
                _context4.next = 15;
                return __await(result.value || []);

              case 15:
                _context4.next = 17;
                return _context4.sent;

              case 17:
                _context4.next = 8;
                break;

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, getModelsPagingPage_1, this);
      }));
    }
  }, {
    key: "getModelsPagingAll",
    value: function getModelsPagingAll(options) {
      return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime().mark(function getModelsPagingAll_1() {
        var e_2, _a, _b, _c, page;

        return _regeneratorRuntime().wrap(function getModelsPagingAll_1$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _b = __asyncValues(this.getModelsPagingPage(options));

              case 2:
                _context5.next = 4;
                return __await(_b.next());

              case 4:
                _c = _context5.sent;

                if (_c.done) {
                  _context5.next = 14;
                  break;
                }

                page = _c.value;
                _context5.t0 = __await;
                return _context5.delegateYield(__asyncDelegator(__asyncValues(page)), "t1", 9);

              case 9:
                _context5.t2 = _context5.t1;
                _context5.next = 12;
                return (0, _context5.t0)(_context5.t2);

              case 12:
                _context5.next = 2;
                break;

              case 14:
                _context5.next = 19;
                break;

              case 16:
                _context5.prev = 16;
                _context5.t3 = _context5["catch"](0);
                e_2 = {
                  error: _context5.t3
                };

              case 19:
                _context5.prev = 19;
                _context5.prev = 20;

                if (!(_c && !_c.done && (_a = _b.return))) {
                  _context5.next = 24;
                  break;
                }

                _context5.next = 24;
                return __await(_a.call(_b));

              case 24:
                _context5.prev = 24;

                if (!e_2) {
                  _context5.next = 27;
                  break;
                }

                throw e_2.error;

              case 27:
                return _context5.finish(24);

              case 28:
                return _context5.finish(19);

              case 29:
              case "end":
                return _context5.stop();
            }
          }
        }, getModelsPagingAll_1, this, [[0, 16, 19, 29], [20,, 24, 28]]);
      }));
    }
    /**
     * Analyzes document with model.
     * @param args Includes all the parameters for this operation.
     */

  }, {
    key: "analyzeDocument",
    value: function analyzeDocument() {
      var operationSpec;
      var operationArguments;
      var options;

      if ((arguments.length <= 1 ? undefined : arguments[1]) === "application/octet-stream" || (arguments.length <= 1 ? undefined : arguments[1]) === "application/pdf" || (arguments.length <= 1 ? undefined : arguments[1]) === "application/vnd.openxmlformats-officedocument.presentationml.presentation" || (arguments.length <= 1 ? undefined : arguments[1]) === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || (arguments.length <= 1 ? undefined : arguments[1]) === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || (arguments.length <= 1 ? undefined : arguments[1]) === "image/bmp" || (arguments.length <= 1 ? undefined : arguments[1]) === "image/heif" || (arguments.length <= 1 ? undefined : arguments[1]) === "image/jpeg" || (arguments.length <= 1 ? undefined : arguments[1]) === "image/png" || (arguments.length <= 1 ? undefined : arguments[1]) === "image/tiff") {
        operationSpec = analyzeDocument$binaryOperationSpec;
        operationArguments = {
          modelId: arguments.length <= 0 ? undefined : arguments[0],
          contentType: arguments.length <= 1 ? undefined : arguments[1],
          options: arguments.length <= 2 ? undefined : arguments[2]
        };
        options = arguments.length <= 2 ? undefined : arguments[2];
      } else if ((arguments.length <= 1 ? undefined : arguments[1]) === "text/html") {
        operationSpec = analyzeDocument$textOperationSpec;
        operationArguments = {
          modelId: arguments.length <= 0 ? undefined : arguments[0],
          contentType: arguments.length <= 1 ? undefined : arguments[1],
          options: arguments.length <= 2 ? undefined : arguments[2]
        };
        options = arguments.length <= 2 ? undefined : arguments[2];
      } else if ((arguments.length <= 1 ? undefined : arguments[1]) === "application/json") {
        operationSpec = analyzeDocument$jsonOperationSpec;
        operationArguments = {
          modelId: arguments.length <= 0 ? undefined : arguments[0],
          contentType: arguments.length <= 1 ? undefined : arguments[1],
          options: arguments.length <= 2 ? undefined : arguments[2]
        };
        options = arguments.length <= 2 ? undefined : arguments[2];
      } else {
        throw new TypeError("\"contentType\" must be a valid value but instead was \"".concat(arguments.length <= 1 ? undefined : arguments[1], "\"."));
      }

      operationArguments.options = options || {};
      return this.sendOperationRequest(operationArguments, operationSpec);
    }
    /**
     * Gets the result of document analysis.
     * @param modelId Unique model name.
     * @param resultId Analyze operation result ID.
     * @param options The options parameters.
     */

  }, {
    key: "getAnalyzeDocumentResult",
    value: function getAnalyzeDocumentResult(modelId, resultId, options) {
      return this.sendOperationRequest({
        modelId: modelId,
        resultId: resultId,
        options: options
      }, getAnalyzeDocumentResultOperationSpec);
    }
    /**
     * Builds a custom document analysis model.
     * @param buildRequest Building request parameters.
     * @param options The options parameters.
     */

  }, {
    key: "buildDocumentModel",
    value: function buildDocumentModel(buildRequest, options) {
      return this.sendOperationRequest({
        buildRequest: buildRequest,
        options: options
      }, buildDocumentModelOperationSpec);
    }
    /**
     * Creates a new model from document types of existing models.
     * @param composeRequest Compose request parameters.
     * @param options The options parameters.
     */

  }, {
    key: "composeDocumentModel",
    value: function composeDocumentModel(composeRequest, options) {
      return this.sendOperationRequest({
        composeRequest: composeRequest,
        options: options
      }, composeDocumentModelOperationSpec);
    }
    /**
     * Generates authorization to copy a model to this location with specified modelId and optional
     * description.
     * @param authorizeCopyRequest Authorize copy request parameters.
     * @param options The options parameters.
     */

  }, {
    key: "authorizeCopyDocumentModel",
    value: function authorizeCopyDocumentModel(authorizeCopyRequest, options) {
      return this.sendOperationRequest({
        authorizeCopyRequest: authorizeCopyRequest,
        options: options
      }, authorizeCopyDocumentModelOperationSpec);
    }
    /**
     * Copies model to the target resource, region, and modelId.
     * @param modelId Unique model name.
     * @param copyToRequest Copy to request parameters.
     * @param options The options parameters.
     */

  }, {
    key: "copyDocumentModelTo",
    value: function copyDocumentModelTo(modelId, copyToRequest, options) {
      return this.sendOperationRequest({
        modelId: modelId,
        copyToRequest: copyToRequest,
        options: options
      }, copyDocumentModelToOperationSpec);
    }
    /**
     * Lists all operations.
     * @param options The options parameters.
     */

  }, {
    key: "_getOperations",
    value: function _getOperations(options) {
      return this.sendOperationRequest({
        options: options
      }, getOperationsOperationSpec);
    }
    /**
     * Gets operation info.
     * @param operationId Unique operation ID.
     * @param options The options parameters.
     */

  }, {
    key: "getOperation",
    value: function getOperation(operationId, options) {
      return this.sendOperationRequest({
        operationId: operationId,
        options: options
      }, getOperationOperationSpec);
    }
    /**
     * List all models
     * @param options The options parameters.
     */

  }, {
    key: "_getModels",
    value: function _getModels(options) {
      return this.sendOperationRequest({
        options: options
      }, getModelsOperationSpec);
    }
    /**
     * Gets detailed model information.
     * @param modelId Unique model name.
     * @param options The options parameters.
     */

  }, {
    key: "getModel",
    value: function getModel(modelId, options) {
      return this.sendOperationRequest({
        modelId: modelId,
        options: options
      }, getModelOperationSpec);
    }
    /**
     * Deletes model.
     * @param modelId Unique model name.
     * @param options The options parameters.
     */

  }, {
    key: "deleteModel",
    value: function deleteModel(modelId, options) {
      return this.sendOperationRequest({
        modelId: modelId,
        options: options
      }, deleteModelOperationSpec);
    }
    /**
     * Return basic info about the current resource.
     * @param options The options parameters.
     */

  }, {
    key: "getInfo",
    value: function getInfo(options) {
      return this.sendOperationRequest({
        options: options
      }, getInfoOperationSpec);
    }
    /**
     * GetOperationsNext
     * @param nextLink The nextLink from the previous successful call to the GetOperations method.
     * @param options The options parameters.
     */

  }, {
    key: "_getOperationsNext",
    value: function _getOperationsNext(nextLink, options) {
      return this.sendOperationRequest({
        nextLink: nextLink,
        options: options
      }, getOperationsNextOperationSpec);
    }
    /**
     * GetModelsNext
     * @param nextLink The nextLink from the previous successful call to the GetModels method.
     * @param options The options parameters.
     */

  }, {
    key: "_getModelsNext",
    value: function _getModelsNext(nextLink, options) {
      return this.sendOperationRequest({
        nextLink: nextLink,
        options: options
      }, getModelsNextOperationSpec);
    }
  }]);

  return GeneratedClient;
}(coreClient.ServiceClient); // Operation Specifications

var serializer = coreClient.createSerializer(Mappers,
/* isXml */
false);
var analyzeDocument$binaryOperationSpec = {
  path: "/documentModels/{modelId}:analyze",
  httpMethod: "POST",
  responses: {
    202: {
      headersMapper: Mappers.GeneratedClientAnalyzeDocumentHeaders
    },
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  requestBody: Parameters.analyzeRequest,
  queryParameters: [Parameters.pages, Parameters.locale, Parameters.stringIndexType, Parameters.apiVersion],
  urlParameters: [Parameters.endpoint, Parameters.modelId],
  headerParameters: [Parameters.contentType, Parameters.accept],
  mediaType: "binary",
  serializer: serializer
};
var analyzeDocument$textOperationSpec = {
  path: "/documentModels/{modelId}:analyze",
  httpMethod: "POST",
  responses: {
    202: {
      headersMapper: Mappers.GeneratedClientAnalyzeDocumentHeaders
    },
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  requestBody: Parameters.analyzeRequest1,
  queryParameters: [Parameters.pages, Parameters.locale, Parameters.stringIndexType, Parameters.apiVersion],
  urlParameters: [Parameters.endpoint, Parameters.modelId],
  headerParameters: [Parameters.contentType1, Parameters.accept1],
  mediaType: "text",
  serializer: serializer
};
var analyzeDocument$jsonOperationSpec = {
  path: "/documentModels/{modelId}:analyze",
  httpMethod: "POST",
  responses: {
    202: {
      headersMapper: Mappers.GeneratedClientAnalyzeDocumentHeaders
    },
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  requestBody: Parameters.analyzeRequest2,
  queryParameters: [Parameters.pages, Parameters.locale, Parameters.stringIndexType, Parameters.apiVersion],
  urlParameters: [Parameters.endpoint, Parameters.modelId],
  headerParameters: [Parameters.contentType2, Parameters.accept2],
  mediaType: "json",
  serializer: serializer
};
var getAnalyzeDocumentResultOperationSpec = {
  path: "/documentModels/{modelId}/analyzeResults/{resultId}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.AnalyzeResultOperation
    },
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  queryParameters: [Parameters.apiVersion],
  urlParameters: [Parameters.endpoint, Parameters.modelId, Parameters.resultId],
  headerParameters: [Parameters.accept2],
  serializer: serializer
};
var buildDocumentModelOperationSpec = {
  path: "/documentModels:build",
  httpMethod: "POST",
  responses: {
    202: {
      headersMapper: Mappers.GeneratedClientBuildDocumentModelHeaders
    },
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  requestBody: Parameters.buildRequest,
  queryParameters: [Parameters.apiVersion],
  urlParameters: [Parameters.endpoint],
  headerParameters: [Parameters.accept2, Parameters.contentType3],
  mediaType: "json",
  serializer: serializer
};
var composeDocumentModelOperationSpec = {
  path: "/documentModels:compose",
  httpMethod: "POST",
  responses: {
    202: {
      headersMapper: Mappers.GeneratedClientComposeDocumentModelHeaders
    },
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  requestBody: Parameters.composeRequest,
  queryParameters: [Parameters.apiVersion],
  urlParameters: [Parameters.endpoint],
  headerParameters: [Parameters.accept2, Parameters.contentType3],
  mediaType: "json",
  serializer: serializer
};
var authorizeCopyDocumentModelOperationSpec = {
  path: "/documentModels:authorizeCopy",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.CopyAuthorization
    },
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  requestBody: Parameters.authorizeCopyRequest,
  queryParameters: [Parameters.apiVersion],
  urlParameters: [Parameters.endpoint],
  headerParameters: [Parameters.accept2, Parameters.contentType3],
  mediaType: "json",
  serializer: serializer
};
var copyDocumentModelToOperationSpec = {
  path: "/documentModels/{modelId}:copyTo",
  httpMethod: "POST",
  responses: {
    202: {
      headersMapper: Mappers.GeneratedClientCopyDocumentModelToHeaders
    },
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  requestBody: Parameters.copyToRequest,
  queryParameters: [Parameters.apiVersion],
  urlParameters: [Parameters.endpoint, Parameters.modelId],
  headerParameters: [Parameters.accept2, Parameters.contentType3],
  mediaType: "json",
  serializer: serializer
};
var getOperationsOperationSpec = {
  path: "/operations",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.GetOperationsResponse
    },
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  queryParameters: [Parameters.apiVersion],
  urlParameters: [Parameters.endpoint],
  headerParameters: [Parameters.accept2],
  serializer: serializer
};
var getOperationOperationSpec = {
  path: "/operations/{operationId}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.GetOperationResponse
    },
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  queryParameters: [Parameters.apiVersion],
  urlParameters: [Parameters.endpoint, Parameters.operationId],
  headerParameters: [Parameters.accept2],
  serializer: serializer
};
var getModelsOperationSpec = {
  path: "/documentModels",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.GetModelsResponse
    },
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  queryParameters: [Parameters.apiVersion],
  urlParameters: [Parameters.endpoint],
  headerParameters: [Parameters.accept2],
  serializer: serializer
};
var getModelOperationSpec = {
  path: "/documentModels/{modelId}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.ModelInfo
    },
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  queryParameters: [Parameters.apiVersion],
  urlParameters: [Parameters.endpoint, Parameters.modelId],
  headerParameters: [Parameters.accept2],
  serializer: serializer
};
var deleteModelOperationSpec = {
  path: "/documentModels/{modelId}",
  httpMethod: "DELETE",
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  queryParameters: [Parameters.apiVersion],
  urlParameters: [Parameters.endpoint, Parameters.modelId],
  headerParameters: [Parameters.accept2],
  serializer: serializer
};
var getInfoOperationSpec = {
  path: "/info",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.GetInfoResponse
    },
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  queryParameters: [Parameters.apiVersion],
  urlParameters: [Parameters.endpoint],
  headerParameters: [Parameters.accept2],
  serializer: serializer
};
var getOperationsNextOperationSpec = {
  path: "{nextLink}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.GetOperationsResponse
    },
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  queryParameters: [Parameters.apiVersion],
  urlParameters: [Parameters.endpoint, Parameters.nextLink],
  headerParameters: [Parameters.accept2],
  serializer: serializer
};
var getModelsNextOperationSpec = {
  path: "{nextLink}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.GetModelsResponse
    },
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  queryParameters: [Parameters.apiVersion],
  urlParameters: [Parameters.endpoint, Parameters.nextLink],
  headerParameters: [Parameters.accept2],
  serializer: serializer
};